import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../views/Login.vue";
import TTDashboard from "../views/dashboard/TTDashboard.vue";
import FBDashboard from "../views/dashboard/FBDashboard.vue";
import KwaiDashboard from "../views/dashboard/KwaiDashboard.vue";
import GoogleDashboard from "../views/dashboard/GoogleDashboard.vue";
import CombinedDashboard from "../views/dashboard/CombinedDashboard.vue";
import DataGroups from "../views/DataGroups.vue";
import UserManagement from "../views/UserManagement.vue";
import DataBoard from "@/views/DataBoard.vue";
import NodeTest from "@/views/NodeTest.vue";
import store from "@/store";
import HotWords from "@/views/HotWords.vue";
import DataDetail from "../views/dashboard/DataDetail.vue";
import DailySummary from "../views/tt-management/DailySummary.vue";
import DataSummary from "../views/tt-management/DataSummary.vue";
import DetailedData from "../views/tt-management/DetailedData.vue";
import DataLocations from "../views/tt-management/DataLocations.vue";
import TTManagement from "../views/tt-management/TTManagement.vue";
import CIDSummary from "../views/tt-management/CIDSummary.vue";
import AdsenseSummary from "../views/tt-management/AdsenseSummary.vue";
import CreateAd from "../views/tt-management/CreateAd.vue";
import FacebookManagement from "../views/dashboard/FacebookManagement.vue";
import AccountRelationship from "../views/AccountRelationship.vue";
import GoogleManagement from "../views/google-management/GoogleManagement.vue";
import GoogleCreateAsset from "../views/google-management/CreateAsset.vue";
import GoogleCreateAd from "../views/google-management/CreateAd.vue";
import FBManagement from "../views/fb-management/FBManagement.vue";
import FBCreateAsset from "../views/fb-management/CreateAsset.vue";
import FBCreateAd from "../views/fb-management/CreateAd.vue";

Vue.use(VueRouter);

const routes = [
    {
        path: "/login",
        name: "Login",
        component: Login,
        meta: { requiresAuth: false },
    },
    {
        path: "/dashboard/tt",
        name: "TTDashboard",
        component: TTDashboard,
        meta: { requiresAuth: true },
    },
    {
        path: "/dashboard/fb",
        name: "FBDashboard",
        component: FBDashboard,
        meta: { requiresAuth: true },
    },
    {
        path: "/dashboard/kwai",
        name: "KwaiDashboard",
        component: KwaiDashboard,
        meta: { requiresAuth: true },
    },
    {
        path: "/dashboard/google",
        name: "GoogleDashboard",
        component: GoogleDashboard,
        meta: { requiresAuth: true },
    },
    {
        path: "/dashboard/combined",
        name: "CombinedDashboard",
        component: CombinedDashboard,
        meta: { requiresAuth: true },
    },
    {
        path: "/data-groups",
        name: "DataGroups",
        component: DataGroups,
        meta: {
            requiresAuth: true,
            allowedTypes: [1, 2, "1,2"],
        },
    },
    {
        path: "/node-test",
        name: "NodeTest",
        component: NodeTest,
        meta: { requiresAuth: true },
    },
    {
        path: "/user-management",
        name: "UserManagement",
        component: UserManagement,
        meta: { requiresAuth: true, requiresAdmin: true },
    },
    {
        path: "/data-board",
        name: "DataBoard",
        component: DataBoard,
    },
    {
        path: "/hot-words",
        name: "HotWords",
        component: HotWords,
        meta: { requiresAuth: true },
    },
    {
        path: "/dashboard/detail/:sid",
        name: "DataDetail",
        component: DataDetail,
        meta: { requiresAuth: true },
        props: true,
    },
    {
        path: "/tt-management",
        name: "TTManagement",
        component: TTManagement,
        meta: {
            requiresAuth: true,
            allowedTypes: [1, 2],
        },
        redirect: "/tt-management/daily",
        children: [
            {
                path: "daily",
                name: "DailySummary",
                component: DailySummary,
                meta: { requiresAuth: true, requiresAdmin: true },
            },
            {
                path: "summary",
                name: "DataSummary",
                component: DataSummary,
                meta: { requiresAuth: true },
            },
            {
                path: "details",
                name: "DetailedData",
                component: DetailedData,
                meta: { requiresAuth: true },
            },
            {
                path: "locations",
                name: "DataLocations",
                component: DataLocations,
                meta: { requiresAuth: true, requiresAdmin: true },
            },
            {
                path: "adsense",
                name: "AdsenseSummary",
                component: AdsenseSummary,
                meta: { requiresAuth: true, requiresAdmin: true },
            },
            {
                path: "cid",
                name: "CIDSummary",
                component: CIDSummary,
                meta: { requiresAuth: true },
            },
            {
                path: "create-ad",
                name: "CreateAd",
                component: CreateAd,
                meta: { requiresAuth: true },
            },
        ],
    },
    {
        path: "/google-management",
        name: "GoogleManagement",
        component: GoogleManagement,
        meta: {
            requiresAuth: true,
        },
        redirect: "/google-management/create-asset",
        children: [
            {
                path: "create-asset",
                name: "GoogleCreateAsset",
                component: GoogleCreateAsset,
                meta: { requiresAuth: true },
            },
            {
                path: "create-ad",
                name: "GoogleCreateAd",
                component: GoogleCreateAd,
                meta: { requiresAuth: true },
            },
        ],
    },
    {
        path: "/fb-management",
        name: "FBManagement",
        component: FBManagement,
        meta: {
            requiresAuth: true,
        },
        redirect: "/fb-management/create-asset",
        children: [
            {
                path: "create-asset",
                name: "FBCreateAsset",
                component: FBCreateAsset,
                meta: { requiresAuth: true },
            },
            {
                path: "create-ad",
                name: "FBCreateAd",
                component: FBCreateAd,
                meta: { requiresAuth: true },
            },
        ],
    },
    {
        path: "/facebook",
        name: "FacebookManagement",
        component: FacebookManagement,
        meta: {
            requiresAuth: true,
            allowedTypes: [1],
        },
    },
    {
        path: "/account-relationship",
        name: "AccountRelationship",
        component: AccountRelationship,
        meta: { requiresAuth: true },
    },
    {
        path: "/",
        redirect: "/dashboard/tt",
    },
];

const router = new VueRouter({
    mode: "history",
    routes,
});

router.beforeEach(async (to, from, next) => {
    console.log("路由守卫 - to.path:", to.path, "from.path:", from?.path);

    if (to.path === "/login" || to.path === "/afstest/login") {
        next();
        return;
    }

    try {
        const isLoggedIn = await store.dispatch("user/checkLoginStatus");
        console.log("路由守卫 - isLoggedIn:", isLoggedIn, "to.meta:", to.meta);

        if (!isLoggedIn && to.meta.requiresAuth) {
            store.commit("dataGroups/CLEAR_DATA", null, { root: true });
            store.commit("user/CLEAR_USER_DATA");
            next({
                path: "/login",
                query: { redirect: to.fullPath },
            });
            return;
        }

        // 检查用户类型权限
        if (to.meta.allowedTypes && isLoggedIn) {
            const userType = store.state.user.userType;
            const allowedTypes = to.meta.allowedTypes;
            const userTypeStr = String(userType);
            console.log(
                "权限检查 - 路由:",
                to.path,
                "userType:",
                userType,
                "userTypeStr:",
                userTypeStr,
                "allowedTypes:",
                allowedTypes
            );

            const isAllowed = allowedTypes.some((type) => {
                const typeStr = String(type).trim();
                const userTypeNum = Number(userType);
                const typeNum = Number(type);

                // 处理 "1,2" 这种格式
                if (typeStr.includes(",")) {
                    const types = typeStr.split(",").map((t) => t.trim());
                    return (
                        types.includes(userTypeStr) ||
                        types.some((t) => Number(t) === userTypeNum)
                    );
                }

                // 同时比较字符串和数字形式
                return (
                    typeStr === userTypeStr ||
                    typeNum === userTypeNum ||
                    typeNum === userType ||
                    type === userType
                );
            });

            console.log("权限检查 - isAllowed:", isAllowed);

            if (!isAllowed) {
                console.log("权限检查 - 不允许访问，重定向");
                // 根据用户类型重定向到合适的页面，避免循环重定向
                const redirectPath = store.state.user.isSecondaryAdmin
                    ? "/tt-management/summary"
                    : "/dashboard/tt";

                // 如果目标路径和当前路径相同，说明已经在目标页面，直接允许通过
                if (to.path === redirectPath || from?.path === redirectPath) {
                    console.log("权限检查 - 避免循环重定向，允许通过");
                    next();
                    return;
                }

                next(redirectPath);
                return;
            }
        }

        if (
            to.meta.requiresAdmin &&
            !store.state.user.isAdmin &&
            !store.state.user.isSecondaryAdmin
        ) {
            if (store.state.user.isSecondaryAdmin) {
                next("/tt-management/summary");
            } else {
                next("/dashboard/tt");
            }
            return;
        }

        if (
            store.state.user.isSecondaryAdmin &&
            (to.path === "/" ||
                to.path === "/dashboard/tt" ||
                to.path === "/afstest" ||
                to.path === "/afstest/")
        ) {
            next("/tt-management/summary");
            return;
        }

        if (
            to.path === "/" ||
            to.path === "/afstest" ||
            to.path === "/afstest/"
        ) {
            next("/dashboard/tt");
            return;
        }

        console.log("路由守卫 - 允许通过:", to.path);
        next();
    } catch (error) {
        console.error("路由守卫错误:", error);
        // 避免循环重定向，如果已经在登录页就不重定向了
        if (to.path !== "/login") {
            next("/login");
        } else {
            next();
        }
    }
});

export default router;
